import { ApiInstance } from '..';
import { LoginParams } from '../../interface/user/login';

export const login = (data: LoginParams) => {
    // return ApiInstance.getInstance().post('/auth/login/mock', data);
    return ApiInstance.getInstance().post('/api/auth/login', data);
};

export const logout = () => {
    return ApiInstance.getInstance().post('/api/auth/logout', {});
};

export const getUserInfo = () => {
    return ApiInstance.getInstance().get('/api/auth/me');
};
